import BlogCard from "./BlogCard";
import React from "react";
import {useSelector} from "react-redux";
import AOS from "aos";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretRight} from "@fortawesome/free-solid-svg-icons/faCaretRight";

const BlogComponent =(props)=>{
    const blogListData = useSelector((state) => state.webSetting.blogListData);
    console.log(blogListData, 'blogListData')
    React.useEffect(() => {
        AOS.init({
            duration: 800,
            easing: "ease-in-sine",
            delay: 100,
            offset: 100,
        });
        AOS.refresh();
    }, []);
    return (
        <div>
                {props.data?.content?.length > 0 ?
                    <div className="container ">
                        <div className='flex justify-between'>
                            <div className='text-left text-black m-0 w-50 flex'>
                                <h2 className='lg:text-2xl md:text-2xl sm:text-xl font-bold m-5'>{props.data?.title}</h2>
                            </div>
                            {props.data?.call_to_action_link && <div className='mt-5'>
                                <Link to={props.data?.call_to_action_link} className='text-right text-gray w-50 font-bold hover:text-primary'>
                                    <span>View all</span>
                                    <FontAwesomeIcon icon={faCaretRight}/>
                                </Link>
                            </div>}
                        </div>
                        <div className="grid xl:grid-cols-4 lg:grid-cols-4 sm:grid-cols-1 md:grid-cols-2 gap-6 gap-y-8 sm:gap-4 md:gap-7">
                            {props.data?.content?.map((value, index) => {
                                const blogData = blogListData[value.object_value];

                                return  blogData && blogData.photo &&
                                    <BlogCard key={index} data={blogData} />;
                            })}
                        </div>

                    </div>
                    :

                 <div className="container p-10">
                <div className="grid xl:grid-cols-4 lg:grid-cols-4 sm:grid-cols-1 md:grid-cols-2 gap-6 gap-y-8 sm:gap-4 md:gap-7">
                    {Object.values(blogListData)?.map((data, index) => (
                        data.photo && <BlogCard key={index} data={data} />
                    ))}
                </div></div>}
        </div>
    )
}
export default BlogComponent;
